
var handleCatsForOnlyCats = function() {
    if (window.onlyCatsString && window.onlyCatsString != "") {
        $(".category-nav-facet").find("li").not($("#new-arrivals-facet").find("li")).each(function() {
            var thisCat = $(this);
            var deleteThisCat = true;
            $(window.onlyCatsString.split("|")).each(function() {
                if (thisCat.find("#facet_count" + String(this)).length > 0) deleteThisCat = false;
            });
            if (deleteThisCat) $(this).remove();
        });
    }
};

export {handleCatsForOnlyCats}
